import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { appName } from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Helmet } from "react-helmet";
import { Row, Col, Table, Modal } from 'react-bootstrap';
import "react-bootstrap-toggle/dist/bootstrap2-toggle.css";
import Roles from '../../../utils/Roles';
import swal from 'sweetalert';
import Pagination from "react-js-pagination";

import PageTitle from '../../../containers/PageTitle';
import Add from './Add';
import Edit from './Edit';

import Renew from './Renew';

class Registration extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			loginText: 'LOGIN',
			isRedirect: false,
			showAddModal: false,
			showEditModal: false,
			currentPage: 1,
			todosPerPage: 10,
			activePage: 1,
			dataList: [],
			dataView: [],
			editData: [],
			deptList: [],
			reList: [],
			showModal: false,
			rData: [],
		}

		this.handleSearch = this.handleSearch.bind(this);
		this.loadEmployees = this.loadEmployees.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onView = this.onView.bind(this);
	}

	onRenew(index, e) {
		this.setState({ showModal: !this.state.showModal, rData: this.state.dataList[index] });
	}

	onhandleChange(e) {
		this.setState({ dataList: [] });
		//this.state.dept = e.target.value;
		this.setState({ [e.target.name]: e.target.value })
	}

	onView(e) {
		this.loadEmployees();
	}

	componentDidMount() {

		this.loadRenewMonth();
		this.loadDepartments();

	}

	loadDepartments() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('postcategory/getactivecategories/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ deptList: res['data'].data });
				this.setState({ showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	loadRenewMonth() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('acyear/getrenewList/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ reList: res['data'].data });
				this.setState({ showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	loadEmployees() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('employee/getEmployeeListByRenew/' + this.state.dept + '/' + this.state.ryear + '/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ dataList: res['data'].data, showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	handleSearch(e) {
		try {
			var list = this.state.dataList;
			var v = e.target.value.toUpperCase();
			var l = list.filter(function (obj) {
				const name = obj.name.toUpperCase();
				const mobile = obj.mobile.toUpperCase();
				const catname = obj.categoryname.toUpperCase();
				return ((name.indexOf(v) > -1) || (mobile.indexOf(v) > -1) || (catname.indexOf(v) > -1));
			});
			this.setState({ dataView: l });
		}
		catch (error) {
			console.log(error);
		}
	}

	handleEdit(id, e) {
		var list = this.state.dataView;
		var index = list.findIndex(function (obj) { return obj.id == id });
		var l = list[index];
		this.setState({ editData: l, showEditModal: true });
	}

	removeValue(id, e) {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('employee/removeprofile/' + this.state.masterId + '/' + this.state.companyId + '/' + id + '/' + token).then(res => {
			if (res['data'].status == '1') {
				var l = this.state.dataList;
				var index = l.findIndex(function (obj) {
					return (obj.id == id);
				});
				l.splice(index, 1);
				this.setState({ dataList: l, dataView: l, showLoader: false });
				notify.show(res['data'].msg, 'success');
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	handleRemoveClick(id, e) {

		swal({ title: 'Confirm', text: 'Do you want to Delete?', buttons: ['No', 'Yes'] }).then((willYes) => {
			if (willYes) this.removeValue(id, e);
		});

	}

	handlePageChange(pageNumber) {

		this.setState({ activePage: pageNumber });
		this.state.currentPage = Number(pageNumber);
	}

	/*	onhandleChange(e) {
			try {
				var list = this.state.dataList;
				var v = e.target.value;
				if (v == '') {
					this.setState({ dataView: list });
				}
				else {
					var l = list.filter(function (obj) {
						const catname = obj.post_category;
						return (catname == v);
					});
					this.setState({ dataView: l });
				}
			}
			catch (error) {
				console.log(error);
			}
		}*/

	render() {

		const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
		const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
		const currentTodos = this.state.dataList//.slice(indexOfFirstTodo, indexOfLastTodo);
		let sno = indexOfFirstTodo + 1;

		var today = new Date();
		var preyear = today.getFullYear() - 2;
		var curyear = today.getFullYear();

		let YearList = [];
		YearList.push(<option value="">Select Renew Year</option>);
		for (var i = ((new Date()).getFullYear()); i >= ((new Date()).getFullYear()); i--) {
			YearList.push(<option value={i}> {i} </option>);
		}

		return (
			<div>
				<Helmet>
					<title>{appName} | Candidate Registration</title>
				</Helmet>

				<PageTitle title="Candidate List" loading={this.state.showLoader} >
					<div className="text-right">
						{Roles.Can('candidate', 'registration', 'canadd') ?
							<Link to="/candidate/registration" className="btn btn-info btn-sm" >
								<i className="fa fa-plus"></i>  Add Candidate
						</Link> : null}
						&nbsp;
						<button className="btn btn-info btn-sm" onClick={this.loadTestMasters} >
							<i className="fa fa-refresh"></i>
						</button>
					</div>
				</PageTitle>

				<Row style={{ marginBottom: 5 }} >
					<Col md={2}>
						<select name="ryear" className="form-control input-sm" onChange={this.onhandleChange.bind(this)}>
							<option value="">Select M&Y</option>
							{this.state.reList.map((item, i) =>
								<option value={item.renewmonth} >{Sanitize.dateTomonth(item.renewmonth)}</option>
							)}
						</select>
					</Col>
					<Col md={2} >
						<select name="dept" className="form-control input-sm" onChange={this.onhandleChange.bind(this)}>
							<option value="">Select Category</option>
							{this.state.deptList.map((item, i) =>
								<option value={item.id} >{item.categoryname}</option>
							)}
						</select>
					</Col>
					<Col md={1}>
						<button type="submit" className="btn btn-primary btn-sm" onClick={this.onView} >
							<i className="fa fa-check"></i> View
						</button>
					</Col>
					<Col md={3} >
						<input type="text" className="form-control input-sm" placeholder="Search Name Here..." onChange={this.handleSearch} />
					</Col>
					<Col md={2}>
						<i className='fa fa-circle' style={{ fontSize: "15px", color: "#d2f6fb" }}>&emsp;<span style={{ color: 'black' }}> Called for Interview</span></i>
					</Col>
					<Col md={2}>
						<i className='fa fa-circle' style={{ fontSize: "15px", color: "#def1cd" }}>&emsp; <span style={{ color: 'black' }}>Appointed</span></i>
					</Col>
				</Row><br />
				<Row>
					<Col md={12} >
						<table width="100%">
							<thead>
								<tr>
									<th style={{ fontSize: "22px", textAlign: 'center' }}>TDTA TIRUNELVELI DIOCESE</th>
								</tr>
								<tr>
									<th style={{ fontSize: "20px", textAlign: 'center' }}>Seniority List - {Sanitize.dateTomonth(this.state.ryear)}</th>
								</tr>
							</thead>
						</table>
					</Col>
				</Row><br />
				{/*<span style={{ color: "#17a2b8", fontSize: "18px", textAlign: 'center' }}><center>(This list generated on May,2018)</center></span>*/}
				<span style={{ color: "red", fontSize: "18px", textAlign: 'left' }}> N/G  - Not Generated</span>
				<Row>
					<Col md={12} >
						<Table hover responsive className="list-table" >
							<thead>
								<tr>
									<th width="60" >SR.No</th>
									<th>Registration Year</th>
									<th>Year of Passing</th>
									<th>Candidate Name</th>
									<th>DOB</th>
									<th>Qualification</th>
									<th>Address</th>
									<th>Mobile</th>
									<th>Status</th>
									<th width="120" >Manage</th>
								</tr>
							</thead>
							<tbody>
								{Object.keys(currentTodos).length > 0 ?
									currentTodos.map((item, key) => {
										return <tr key={key} className={(item.appstatus === 'pending' ? 'td_bg-blue' : '')}>
											<td align='center'>{item.renew_seniority != '' && item.renew_seniority != null ? item.renew_seniority : <span style={{ fontWeight: 'bold', color: 'red' }}>N/G</span>}</td>
											<td>{item.for_year}</td>
											<td>{Sanitize.getMonthName(item.passmonth)} {item.passyear}<br />{Sanitize.dateTomonth(item.sptraining_year)}</td>
											<td>{item.name}<br />{item.splcategory != '' && item.splcategory != null ? '(' + item.splcategory + ')' : ''}</td>
											<td width="80">{Sanitize.dmyDash(item.dob)}</td>
											<td>{item.qualification}</td>
											<td>{item.address} - {item.pincode}</td>
											<td>{item.mobile}</td>
											<td align="center" >{Sanitize.getStatus(item.empstatus)}</td>
											<td align="center" >
												<button className="btn btn-info btn-sm btn-lowpadding" onClick={this.onRenew.bind(this, key)}>
													<i className="fa fa-eye"></i>
												</button>&nbsp;&nbsp;
										{Roles.Can('candidate', 'registration', 'canedit') ?
													<Link to={'/candidate/edit/' + item.id} className="btn btn-sm btn-warning btn-lowpadding" onClick={this.handleEdit.bind(this, item.id)} >
														<i className="fa fa-edit"></i>
													</Link> : null}
												&nbsp;&nbsp;
										{Roles.Can('candidate', 'registration', 'candelete') ?
													<button className="btn btn-sm btn-danger btn-lowpadding" onClick={this.handleRemoveClick.bind(this, item.id)} >
														<i className="fa fa-remove"></i>
													</button> : null}
											</td>
										</tr>;
									})
									: <tr>
										<td colSpan="10" align="center" style={{ fontSize: '18px', color: 'brown' }}>
											No data found..!
								</td>
									</tr>
								}
							</tbody>
						</Table>
					</Col>
				</Row>

				{/*<Row>
					<Col md={1} >
						<select className="form-control input-sm" onChange={(e)=>{this.setState({activePage:1,currentPage:Number(1), todosPerPage: e.target.value})}} >
							<option value="10"> 10 </option>
							<option value="15"> 15 </option>
							<option value="20"> 20 </option>
							<option value="50"> 50 </option>
							<option value="100"> 100 </option>
						</select>
					</Col>
					<Col md={10} >
						 <Pagination
						  activePage={this.state.activePage}
						  itemsCountPerPage={this.state.todosPerPage}
						  totalItemsCount={(this.state.dataView).length}
						  pageRangeDisplayed={7}
						  onChange={(pN)=>{this.setState({activePage:pN, currentPage: Number(pN)})}}
						/>
					</Col>
				</Row>*/}

				<Modal size="lg" show={this.state.showAddModal} onHide={() => { this.setState({ showAddModal: false }) }} className="" >
					<Modal.Header closeButton >
						<Modal.Title>Add Candidate</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Add afterFinish={this.loadTestMasters} />
					</Modal.Body>
				</Modal>

				<Modal size="lg" show={this.state.showEditModal} onHide={() => { this.setState({ showEditModal: false }) }} className="" >
					<Modal.Header closeButton >
						<Modal.Title>Edit Test</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Edit editData={this.state.editData} afterFinish={this.loadTestMasters} />
					</Modal.Body>
				</Modal>

				<Modal size="md" show={this.state.showModal} onHide={() => { this.setState({ showModal: false }) }} className="" >
					<Modal.Header closeButton >
						<Modal.Title>Profile</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Renew rData={this.state.rData} afterFinish={() => { this.setState({ showModal: false, rData: [] }) }} />
					</Modal.Body>
				</Modal>

			</div>
		);
	}

}
export default Registration;